
export default function AppNotificationsController($scope, $uibModalInstance, notification) {
  'ngInject';
  $scope.activeNotifications = notification;

  $scope.acknowledge = function () {
	$uibModalInstance.close($scope.activeNotifications);
  };

  $scope.cancel = function () {
	$uibModalInstance.dismiss('cancel');
  }
}
